document.addEventListener("DOMContentLoaded", function () {

  // ❌ Checkout page par bilkul nahi chalega
  if (window.location.pathname.indexOf('/checkout') !== -1) return;

  var today = new Date();
  var month = today.getMonth(); // 0 = Jan, 11 = Dec
  var date = today.getDate();

  var isMobile = window.innerWidth < 768;

  // 🔽 LOW DENSITY SETTINGS (premium look)
  var intervalTime = isMobile ? 1800 : 1000; // particle gap
  var fireworkChance = 0.85; // fireworks very rare

  var mode = null;

  // 🎄 CHRISTMAS: 25 Dec – 8 Jan
  if (
    (month === 11 && date >= 25) || // Dec 25–31
    (month === 0 && date <= 8)     // Jan 1–8
  ) {
    mode = "christmas";
  }

  // 🇮🇳 INDIA: 20 Jan – 28 Jan ONLY
  if (month === 0 && date >= 20 && date <= 28) {
    mode = "india";
  }

  // ❌ Rest of the year OFF
  if (!mode) return;

  // ⭐ Container
  var container = document.createElement("div");
  container.className = "christmas-stars";
  document.body.appendChild(container);

  var icons, colors;

  if (mode === "christmas") {
    icons = ["❄", "🎄"];
    colors = ["#FFFFFF", "#FFD700"];
  } else {
    icons = ["🇮🇳", "☸"];
    colors = ["#FF9933", "#FFFFFF", "#138808"]; // Tricolor
  }

  function createEffect() {
    var el = document.createElement("div");

    // 🎆 VERY RARE FIREWORKS (India days only)
    if (mode === "india" && Math.random() > fireworkChance) {
      el.className = "firework";

      // 👉 LEFT / RIGHT ONLY (NO CENTER)
      var side = Math.random() > 0.5 ? "left" : "right";
      el.style.left =
        side === "left"
          ? Math.random() * 15 + "vw"        // 0–15%
          : 85 + Math.random() * 15 + "vw"; // 85–100%

      el.style.top = Math.random() * 40 + "vh";
      el.style.width = "5px";
      el.style.height = "5px";
      el.style.background =
        colors[Math.floor(Math.random() * colors.length)];

      container.appendChild(el);

      setTimeout(function () {
        el.remove();
      }, 1800);
      return;
    }

    // ⭐ FALLING ICON (LEFT / RIGHT EDGES ONLY)
    el.className = "star";
    el.innerHTML = icons[Math.floor(Math.random() * icons.length)];

    var side = Math.random() > 0.5 ? "left" : "right";
    el.style.left =
      side === "left"
        ? Math.random() * 20 + "vw"        // 0–20%
        : 80 + Math.random() * 20 + "vw"; // 80–100%

    el.style.animationDuration =
      (isMobile ? 10 : 8) + Math.random() * 4 + "s";
    el.style.fontSize =
      (isMobile ? 11 : 14) + Math.random() * 6 + "px";
    el.style.color =
      colors[Math.floor(Math.random() * colors.length)];

    container.appendChild(el);

    setTimeout(function () {
      el.remove();
    }, 16000);
  }

  setInterval(createEffect, intervalTime);
});